import ChangePassword from "./ChangePassword";
import MailOtp from "./MailOtp";
import Pairing from "./Pairing";
import Passkey from "./Passkey";
import SecurityKey from "./SecurityKey";
import SmartOtp from "./SmartOtp";
import GeneratePassword from "./GeneratePassword";
import ImportForm from "./ImportForm";

const formsComponents = {
  ChangePassword,
  MailOtp,
  Pairing,
  Passkey,
  SecurityKey,
  SmartOtp,
  GeneratePassword,
  ImportForm,
}

export default formsComponents